import {ReportModel} from "@fedeltapointofsale/data-client";
import {
    SalesByHourReportData} from "./sales-by-hour-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class SalesByHourReportModel extends ReportModel<SalesByHourReportData> {
    constructor(injector: Injector) {
        super(injector, SalesByHourReportData);
    }
}
